import React, { Fragment, useEffect } from 'react';
import { Provider, useDispatch, useSelector } from "react-redux";

import "../commons/fonts/SF-Pro/SF-Pro-Display-Black.otf";

import '../commons/templates/custom.css';
import '../commons/templates/account-style.css';
import 'react-toastify/dist/ReactToastify.css';

import store from "../store/store";
import Sidebar from "../commons/components/sidebar";
import Menu from "../commons/templates/menu";
import Header from "../commons/components/header";
import { ToastContainer } from "react-toastify";
import { initApp } from "../store/actions/appLoadingActions";

import { ConfigProvider, Layout } from "antd";
import 'moment/locale/pt-br';
import locale from 'antd/lib/locale/pt_BR';

export default props => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initApp());
    }, []);

    return (
        <Provider className="App" store={store}>
            <ConfigProvider locale={locale}>
                <Fragment>
                    <Layout style={{ minHeight: '100vh' }}>
                        <Header applicationId={2} />
                        <Layout>
                            <Sidebar>
                                <Menu />
                            </Sidebar>
                            {props.children}
                        </Layout>
                    </Layout>
                    <ToastContainer
                        position="bottom-center"
                        autoClose={10000}
                        hideProgressBar
                        closeButton={false}
                        toastClassName={"account-toast"} />
                </Fragment>
            </ConfigProvider>
        </Provider>
    )
}


